import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// import { connect } from 'react-redux';
import classNames from 'classnames';

// import EndResultFines from './EndResultFines';
// import EndResultPules from './EndResultPules';

import {
  Row, Col, Button, Media, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';

import { getBetValue } from '../../../../../../common/services/data-service';
import infoImg from '../../../../../../images/redesign/player/info.svg';
import PulesHelpInfo from './PulesHelpInfo';
import CustomModal from '../../../Components/Components/Modal';
import { renderNum } from '../../../../../../utils/stringUtils';

const ScoreTableSum2p = ({
  myPos, totalPnts, isEndResultTable, gameType, bet, t, globalParams, players, showInfoModal, player1Pules, player2Pules, player1ShortName, player2ShortName
}) => {
  const {
    minGames, gameState, fourPRoom, rPlayed, closeReason,
  } = globalParams;
  const [openPluesInfoModal, setOpenPluesInfoModal] = useState(false);
  const { i18n } = useTranslation();
  const lang = i18n.language || '';

  let betRatio;

  if (bet) {
    betRatio = parseInt(bet.replace('1:', ''), 10);
  }

  let betValue;
  let leavePenalty;
  let leaveReward;
  let penaltyPlayer;

  if (players && closeReason && closeReason.reason && (closeReason.reason === 'missedTurn' || closeReason.reason === 'leftRoom')) {
    betValue = getBetValue(bet);

    if (players.player1 && players.player1.uid === closeReason.playerUid) {
      penaltyPlayer = 'player1';
    } else if (players.player2 && players.player2.uid === closeReason.playerUid) {
      penaltyPlayer = 'player2';
    }

    if (closeReason.isAutomated) {
      leavePenalty = 0;
      leaveReward = 0;
    } else {
      leavePenalty = Math.round(betValue * 8);
      leaveReward = Math.round(0.25 * leavePenalty);
    }

    console.log('closeReason', { closeReason, minGames, rPlayed });

    if (closeReason.reason === 'leftRoom') {
      if (minGames && (rPlayed || rPlayed === 0) && minGames > (rPlayed) && betValue) {
        leavePenalty += Math.round((minGames - rPlayed) * 10 * betValue);

        leaveReward += Math.round(0.25 * (minGames - rPlayed) * 10 * betValue);
      }
    } else if (minGames && (rPlayed || rPlayed === 0) && minGames > rPlayed && betValue) {
      leavePenalty += Math.round((minGames - rPlayed) * 10 * betValue);

      leaveReward += Math.round(0.25 * (minGames - rPlayed) * 10 * betValue);
    }
  }

  return (
    <Row className="end-result-score-table-sum">
      <Col sm="12">
        <Row className="end-result-table-header-landscape">
        </Row>
        <Row className="end-result-table-header mt-3">
          <Col className="end-result-table-header-col">
            {t('game:points')}
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive': (myPos === 'player1' && totalPnts && totalPnts.player1 > 0) || (myPos === 'player2' && totalPnts && totalPnts.player2 > 0),
              'player-history-table-col-negative': (myPos === 'player1' && (totalPnts && totalPnts.player1 < 0)) || (myPos === 'player2' && (totalPnts && totalPnts.player2 < 0)),
              'player-history-table-col-neutral': (myPos === 'player1' && ((totalPnts && totalPnts.player1 === 0) || !totalPnts?.player1)) || (myPos === 'player2' && ((totalPnts && totalPnts.player2 === 0) || !totalPnts?.player2)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                )}
                {myPos === 'player2' && (
                  <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive': (myPos === 'player1' && totalPnts && totalPnts.player2 > 0) || (myPos === 'player2' && totalPnts && totalPnts.player1 > 0),
              'player-history-table-col-negative': (myPos === 'player1' && (totalPnts && totalPnts.player2 < 0)) || (myPos === 'player2' && (totalPnts && totalPnts.player1 < 0)),
              'player-history-table-col-neutral': (myPos === 'player1' && ((totalPnts && totalPnts.player2 === 0) || !totalPnts?.player2)) || (myPos === 'player2' && ((totalPnts && totalPnts.player1 === 0) || !totalPnts.player1)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                )}
                {myPos === 'player2' && (
                  <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col" />
          <Col className="end-result-table-header-col" />
        </Row>
        <Row className="end-result-table-header mt-3">
          <Col className="end-result-table-header-col">
            {t('game:zoles')}
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive':
                (myPos === 'player1' && totalPnts && betRatio * totalPnts.player1 > 0)
                || (myPos === 'player2' && totalPnts && betRatio * totalPnts.player2 > 0),
              'player-history-table-col-negative':
                (myPos === 'player1' && totalPnts && betRatio * totalPnts.player1 < 0)
                || (myPos === 'player2' && totalPnts && betRatio * totalPnts.player2 < 0),
              'player-history-table-col-neutral':
                (myPos === 'player1' && ((totalPnts && betRatio * totalPnts.player1 === 0) || !totalPnts?.player1))
                || (myPos === 'player2' && ((totalPnts && betRatio * totalPnts.player2 === 0) || !totalPnts?.player2)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>
                    {totalPnts && totalPnts.player1 && betRatio
                      ? renderNum(betRatio * totalPnts.player1)
                      : 0}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {totalPnts && totalPnts.player2 && betRatio
                      ? renderNum(betRatio * totalPnts.player2)
                      : 0}
                  </>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive':
                (myPos === 'player1' && totalPnts && betRatio * totalPnts.player2 > 0)
                || (myPos === 'player2' && totalPnts && betRatio * totalPnts.player1 > 0),
              'player-history-table-col-negative':
                (myPos === 'player1' && totalPnts && betRatio * totalPnts.player2 < 0)
                || (myPos === 'player2' && totalPnts && betRatio * totalPnts.player1 < 0),
              'player-history-table-col-neutral':
                (myPos === 'player1' && ((totalPnts && betRatio * totalPnts.player2 === 0) || !totalPnts?.player2))
                || (myPos === 'player2' && ((totalPnts && betRatio * totalPnts.player1 === 0) || !totalPnts?.player1)),

            })}
            >
              <>
                {myPos === 'player1' && (
                  <>
                    {totalPnts && totalPnts.player2 && betRatio
                      ? renderNum(betRatio * totalPnts.player2)
                      : 0}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {totalPnts && totalPnts.player1 && betRatio
                      ? renderNum(betRatio * totalPnts.player1)
                      : 0}
                  </>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col" />
          <Col className="end-result-table-header-col" />
        </Row>
        {isEndResultTable && (
          <>
            {gameType && gameType.includes('P') && (
              <Row className="end-result-table-header mt-3">
                <Col className="end-result-table-header-col">
                  {t('game:activePules')}
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': (myPos === 'player1' && player1Pules > 0) || (myPos === 'player2' && player2Pules > 0),
                    'player-history-table-col-negative': (myPos === 'player1' && player1Pules < 0) || (myPos === 'player2' && player2Pules < 0),
                    'player-history-table-col-neutral': (myPos === 'player1' && player1Pules === 0) || (myPos === 'player2' && player2Pules === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {player1Pules}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {player2Pules}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': (myPos === 'player1' && player2Pules > 0) || (myPos === 'player2' && player1Pules > 0),
                    'player-history-table-col-negative': (myPos === 'player1' && player2Pules < 0) || (myPos === 'player2' && player1Pules < 0),
                    'player-history-table-col-neutral': (myPos === 'player1' && player2Pules === 0) || (myPos === 'player2' && player1Pules === 0),

                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {player2Pules}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {player1Pules}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col" />
                <Col className="end-result-table-col end-result-table-col-last col">
                  <Media className="end-result-table-header-col-last-info-button" onClick={() => setOpenPluesInfoModal(!openPluesInfoModal)} src={infoImg} alt="x" />
                </Col>
              </Row>
            )}
            {closeReason && closeReason.reason && (closeReason.reason === 'missedTurn' || closeReason.reason === 'leftRoom') && (
              <Row className="end-result-table-header mt-3">
                <Col className="end-result-table-header-col">
                  {closeReason.reason === 'missedTurn' && (
                    t('game:missedTurnPenalty')
                  )}
                  {closeReason.reason === 'leftRoom' && (
                    t('game:leftRoomPenalty')
                  )}
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': ((myPos === 'player1' && penaltyPlayer !== 'player1') || (myPos === 'player2' && penaltyPlayer !== 'player2')) && leaveReward > 0,
                    'player-history-table-col-negative': ((myPos === 'player1' && penaltyPlayer === 'player1') || (myPos === 'player2' && penaltyPlayer === 'player2')) && leavePenalty > 0,
                    'player-history-table-col-neutral': (((myPos === 'player1' && penaltyPlayer !== 'player1') || (myPos === 'player2' && penaltyPlayer !== 'player2')) && leaveReward === 0) ||
                      (((myPos === 'player1' && penaltyPlayer === 'player1') || (myPos === 'player2' && penaltyPlayer === 'player2')) && leavePenalty === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {penaltyPlayer === 'player1' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {penaltyPlayer === 'player2' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': ((myPos === 'player1' && penaltyPlayer !== 'player2') || (myPos === 'player2' && penaltyPlayer !== 'player1')) && leaveReward > 0,
                    'player-history-table-col-negative': ((myPos === 'player1' && penaltyPlayer === 'player2') || (myPos === 'player2' && penaltyPlayer === 'player1')) && leavePenalty > 0,
                    'player-history-table-col-neutral': (((myPos === 'player1' && penaltyPlayer !== 'player2') || (myPos === 'player2' && penaltyPlayer !== 'player1')) && leaveReward === 0) ||
                      (((myPos === 'player1' && penaltyPlayer === 'player2') || (myPos === 'player2' && penaltyPlayer === 'player1')) && leavePenalty === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {penaltyPlayer === 'player2' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {penaltyPlayer === 'player1' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col" />
                <Col className="end-result-table-header-col end-result-table-col-last">
                  <Media className="end-result-table-header-col-last-info-button" onClick={showInfoModal} src={infoImg} alt="x" />
                </Col>
              </Row>
            )}
          </>
        )}
      </Col>
      <CustomModal
        isOpen={openPluesInfoModal}
        toggle={() => setOpenPluesInfoModal(!openPluesInfoModal)}
        title={t('game:pulesDescription')}
        addClassName={"gameinfo-modal"}
        disableFlex
        footerClose
        footer={(
          <>
            <Button className="notification-footer-button" onClick={() => setOpenPluesInfoModal(!openPluesInfoModal)}>
              {t('game:ok')}
            </Button>
          </>
        )}
        body={(
          <div className="gameinfo-modal-content">
            <PulesHelpInfo lang={lang} />
          </div>
        )}
      />
    </Row>
  );
};

ScoreTableSum2p.propTypes = {
  totalPnts: PropTypes.shape(),
  myPos: PropTypes.string,
  isEndResultTable: PropTypes.bool,
  t: PropTypes.func.isRequired,
  showInfoModal: PropTypes.func.isRequired,
  player1Pules: PropTypes.number,
  player2Pules: PropTypes.number,
  globalParams: PropTypes.shape({}),
  players: PropTypes.shape({}),
};

ScoreTableSum2p.defaultProps = {
  totalPnts: {},
  myPos: '',
  isEndResultTable: false,
};

export default ScoreTableSum2p;
